import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { debounceTime, tap } from 'rxjs/operators';

import { clearEmptyProperties } from '@core/utils/filters-utils';
import { BehaviorSubject } from 'rxjs';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filter-groups',
  templateUrl: './filter-groups.component.html',
  encapsulation: ViewEncapsulation.None
})

export class FilterGroupsComponent implements OnInit {

  filtersForm: FormGroup;
  public filterChanged = new BehaviorSubject<any>({
    name_contains: null,
    archived: false
  });

  constructor(
    private formBuilder: FormBuilder,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  async ngOnInit(): Promise<void> {
    this.filtersForm = this.formBuilder.group({
      name: null,
      archived: false
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          name_contains: this.filtersForm.value.name,
          archived: this.filtersForm.value.archived
        });
        this.filterChanged.next(filters);
      })
    ).subscribe();
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      name: null,
      archived: false
    });
  }
}
